module.exports = __webpack_public_path__ + "static/media/twitter-podcast.602e136a.svg";